import { Exclude, Expose, Transform } from 'class-transformer';
import { Database } from 'shared/database.enum';
import { formatNoValueToDash } from 'utils/utils';
import { Image } from '../shared/image';
import { Catalogue } from './catalogue';
import { CatalogueItem } from './catalogue-item';
import { CatalogueBase } from './catalogue-base';

/**
 * An extended catalouge.
 */
@Exclude()
export class CatalogueExtended extends Catalogue implements CatalogueBase {
  // extended catalogue info
  @Expose()
  propertyName: string;

  @Expose()
  @Transform((value, obj) => formatNoValueToDash(obj.propertyName))
  propertyNameDesc: string;

  @Expose()
  address: string;

  @Expose()
  country: string;

  @Expose()
  contactName: string;

  @Expose()
  contactEmail: string;

  @Expose()
  @Transform((value, obj) => formatNoValueToDash(obj.contactEmail))
  contactEmailDesc: string;

  @Expose()
  contactPhoneNumber: string;

  @Expose()
  @Transform((value, obj) => formatNoValueToDash(obj.contactPhoneNumber))
  contactPhoneNumberDesc: string;

  @Expose()
  contactUrl: string;

  @Expose()
  @Transform((value, obj) => formatNoValueToDash(obj.contactUrl))
  contactUrlDesc: string;

  @Expose()
  description: string;

  @Expose()
  dbType: Database;

  @Expose()
  isActive: boolean;

  @Expose()
  onRamSelect: boolean;

  @Expose()
  created: string;

  @Expose()
  catalogueItems: CatalogueItem[];

  @Expose()
  catalogueImages: Image[];

  @Expose()
  auctionUrl: string;
}
